const points = [35, 52, 66, 59, 63, 17, 70, 24, 28, 7, 3, 45, 52, 14, 66, 3, 70, 59, 2, 49, 56, 31, 49, 17, 28, 7, 35, 42, 28, 45];
const color = "rgb(245, 245, 245)";
export default (start=false) => ({
      chart: {type: 'column'},
      tooltip: false,
      plotOptions: {
        series: {
          pointStart: start,
          pointInterval: 86400000,
        },
      },
      series: [{
        name: ' ',
        color: color,
        states: {hover: {color: color}},
        data: points,
      }],
    });



// WEBPACK FOOTER //
// ./src/components/Dashboard/Highcharts/Placeholder.js